import axiosIns from '@/libs/axios'

export default {
  getAll: () => axiosIns.get('auth/audits'),
  getAllByTag: (tag, serverParams) => axiosIns.get(`auth/audits/${tag}?page=${serverParams.page}&perPage=${serverParams.perPage}&sort=${JSON.stringify(serverParams.sort)}&filter=${JSON.stringify(serverParams.columnFilters)}&dateRange=${JSON.stringify(serverParams.dateRange)}`),

}
